/**
 * Trust section. The testimonial is a clearly-marked pilot placeholder —
 * replace the quote once Asia Villa provides real words. No invented
 * results or numbers, per spec.
 */
import { BadgePercent, Quote, Timer, UtensilsCrossed } from 'lucide-react';

const TRUST_BULLETS = [
  { icon: Timer, title: '14-day free trial', text: 'Try everything before you decide. No card details games, no pressure.' },
  { icon: BadgePercent, title: 'No setup fee', text: 'Flat monthly pricing with VAT included — what you see is what you pay.' },
  { icon: UtensilsCrossed, title: 'Restaurant-focused', text: 'Built around rotas, kiosks and service hours — not generic office scheduling.' },
];

export function TrustSection() {
  return (
    <section className="bg-[color:var(--brand-bg-2)] border-y border-[color:var(--brand-border)] scroll-mt-24 [content-visibility:auto]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14 sm:py-20 grid lg:grid-cols-2 gap-8 lg:gap-14 items-center">
        <div>
          <h2 className="text-3xl sm:text-4xl font-display font-semibold tracking-tight" data-testid="marketing-trust-heading">
            Built with restaurants, for restaurants.
          </h2>
          <p className="mt-4 text-base text-[color:var(--brand-text-muted)] leading-relaxed max-w-lg">
            RotaHQ is developed hands-on with working UK restaurants — including our pilot
            partner Asia Villa — so every feature earns its place on a real service floor.
          </p>
          <div className="mt-7 space-y-4">
            {TRUST_BULLETS.map((bullet) => (
              <div key={bullet.title} className="flex items-start gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[color:var(--brand-primary-soft)]">
                  <bullet.icon className="h-4.5 w-4.5 h-5 w-5 text-[color:var(--brand-primary)]" aria-hidden="true" />
                </span>
                <div>
                  <div className="font-semibold text-sm sm:text-base">{bullet.title}</div>
                  <div className="text-sm text-[color:var(--brand-text-muted)]">{bullet.text}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <figure className="surface-card p-6 sm:p-8" data-testid="marketing-trust-testimonial">
          <Quote className="h-7 w-7 text-[color:var(--brand-primary)]" aria-hidden="true" />
          {/* PLACEHOLDER QUOTE — replace with Asia Villa's real words when provided. */}
          <blockquote className="mt-4 text-base sm:text-lg leading-relaxed">
            “We&apos;re working directly with the RotaHQ team as their pilot restaurant —
            shaping the rota, kiosk and payroll tools around how a real kitchen and
            front-of-house actually run.”
          </blockquote>
          <figcaption className="mt-5 flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[color:var(--brand-primary)] text-white font-display font-semibold">AV</span>
            <div>
              <div className="font-semibold text-sm">Asia Villa</div>
              <div className="text-xs text-[color:var(--brand-text-muted)]">Pilot partner restaurant, UK</div>
            </div>
          </figcaption>
        </figure>
      </div>
    </section>
  );
}
